const UserProfile = () => {
  return <h1>Dashboard</h1>;
};

export default UserProfile;
